/* eslint-disable no-undef */
import React from "react";
import ReactDOM from "react-dom";
import "./app/Utils/Scripts/mixPanel";
import "./index.scss";
import "./app/Utils/utils";
import MainApp from "./app/MainApp";
import Shell from "./app/Shell";
import Utils from "./app/Utils/utils";

Utils.checkAddNonceAndCspTag();

const urlParams = new URLSearchParams(window.location.search);
const isAppView = urlParams.get("view") === "app";

ReactDOM.render(
  isAppView ? <MainApp /> : <Shell />,
  document.getElementById("root")
);
